import { Component, inject } from '@angular/core';
import { IonIcon, ModalController } from '@ionic/angular/standalone';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-general-promo',
  templateUrl: './general-promo.component.html',
  styleUrls: ['./general-promo.component.scss'],
  imports: [IonIcon],
  standalone: true
})
export class GeneralPromoComponent {
  private readonly modalController = inject(ModalController);
  private readonly translateService = inject(TranslateService);

  isCN = this.translateService.currentLang === 'cn';

  dismiss() {
    this.modalController.dismiss();
  }
}
